// extracted by mini-css-extract-plugin
export default {"debugConsoleRoot":"DebugConsole_debugConsoleRoot__EB2qA"};